import { render } from "./PickupTable.vue?vue&type=template&id=7df1b810&scoped=true"
import script from "./PickupTable.vue?vue&type=script&lang=js"
export * from "./PickupTable.vue?vue&type=script&lang=js"

import "./PickupTable.vue?vue&type=style&index=0&id=7df1b810&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df1b810"]])

export default __exports__